export const CrashMe = () => {
  throw new Error('This is a Crash Me page');
  // eslint-disable-next-line no-unreachable
  return null;
};
